import { httpClientInternal } from './httpClient'

const END_POINT = '/notes/admin'

const NotesAPI = {
  addReviewNotes({ noteListId, description, attachment, parentObjectId }) {
    const formData = new FormData()
    formData.append('noteListId', noteListId)
    formData.append('parentObjectId', parentObjectId)
    formData.append('description', description)
    formData.append('attachment', attachment)

    return httpClientInternal.post(END_POINT, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  }
}

export default NotesAPI
